import React from 'react';
import ShopPreview from './ShopPreview';

/**
 * Một dòng item trong bảng Quản lý shop (Khung avatar).
 *
 * - PureComponent: khi mount thêm dòng mới, các dòng cũ KHÔNG re-render (props không đổi).
 * - Ô xem trước (<ShopPreview>) chỉ tạo SVGA/ảnh khi lọt vào viewport.
 * - DOM hoàn toàn do React quản lý (KHÔNG dùng jQuery replaceWith).
 * - Các field có thể null đều được guard -> 1 item lỗi không làm sập cả bảng.
 */
class ShopItemRow extends React.PureComponent {
    render() {
        const { gift, onEdit, onDelete, onTransfer, editModalId, deleteModalId } = this.props;
        if (!gift) return null;

        const dateStart = gift.dateStart ? (new Date(gift.dateStart)).toLocaleString('en-GB') : '';
        let dateEnd = '';
        if (gift.dateEnd) {
            const isInfinite = String(gift.dateEnd.toLocaleString()) === '253,402,214,400,000';
            dateEnd = isInfinite ? 'VÔ HẠN' : (new Date(gift.dateEnd)).toLocaleString('en-GB');
        }

        return (
            <tr className="item-row">
                <td><strong>{gift.order}</strong></td>
                <td>{gift._id}</td>
                <td>{gift.name}</td>
                <td>{gift.expiry}</td>
                <td style={{ maxHeight: '50px', maxWidth: '50px' }}>
                    <ShopPreview url={gift.resourceUrl} />
                </td>
                <td>{gift.sourceType}</td>
                <td>{gift.price}</td>
                <td>{dateStart}</td>
                <td>{dateEnd}</td>
                <td>{gift.lvRequire}</td>
                <td>{gift.vipRequire}</td>
                <td>{gift.idAllowed}</td>
                <td>
                    <button
                        onClick={() => onEdit(gift)}
                        className="btn btn-info"
                        data-toggle="modal"
                        data-target={editModalId}
                    >Sửa</button>
                    <button
                        onClick={() => onDelete(gift)}
                        className="btn btn-warning ml-sm-2"
                        data-toggle="modal"
                        data-target={deleteModalId}
                    >Xóa</button>
                </td>
                <td>
                    <button
                        onClick={() => onTransfer(gift)}
                        className="btn btn-warning ml-sm-2"
                    >Chuyển</button>
                </td>
            </tr>
        );
    }
}

ShopItemRow.defaultProps = {
    editModalId: '#modalUpdateAvatarFrame',
    deleteModalId: '#modalDeleteShopItem',
};

export default ShopItemRow;
